import React from 'react';
import { Drawer, Box, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDrawer } from '../../Context/RightDrawerContext';

const RightDrawer = () => {
    const { isDrawerOpen, openDrawer, closeDrawer, toggleDrawer, drawerContent } = useDrawer();
  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => closeDrawer()}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 600, md: 800 },
          boxSizing: 'border-box',
        },
      }}
    >
      <Box sx={{ p: 2 }}>
        {/* Close button */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <IconButton 
            onClick={() => openDrawer()}
            sx={{ color: 'text.primary' }}
          >
            <Close />
          </IconButton>
        </Box>

        {/* Drawer content */}
        {drawerContent}
      </Box>
    </Drawer>
  );
};

export default RightDrawer;